import { render, staticRenderFns } from "./UpdateExecutiveBoard.vue?vue&type=template&id=b7fb2bec&scoped=true"
import script from "./UpdateExecutiveBoard.vue?vue&type=script&lang=js"
export * from "./UpdateExecutiveBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fb2bec",
  null
  
)

export default component.exports